/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import view from './player-road-to-erin-hills.stache';
import BaseWidget from 'scripts/base-widget';
import 'components/qualification-drawer/qualification-drawer';
import can from 'can';

export const playerRoadToErinHills = BaseWidget.extend({
    init: function () {
        this.viewModel = new can.Map({
            qualifyingStatus: this.options.qualifyingStatus,
            exemptions: this.options.player.exemptions,
            sectionalQualifier: this.options.player.sectionalQualifier,
            localQualifier: this.options.player.localQualifier,
            exemptionQualifier: this.options.player.exemptionQualifier,
            identifier: this.options.player.identifier,
            logoImage: this.options.logoImage,
            courseName: this.options.courseName,
            courseCity: this.options.courseCity,
            courseState: this.options.courseState
        });
        this.view = view;
        this._super();
    }
});
